import { render, staticRenderFns } from "./CmgNutritionCalculatorMetricsSummary.vue?vue&type=template&id=08be236c&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-metrics-summary.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-metrics-summary.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMetricsSummary.vue?vue&type=style&index=0&id=08be236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be236c",
  null
  
)

export default component.exports